export default __webpack_public_path__ + "static/media/bigKnotRight.013d6a7f.png";